import React from 'react';

const TYPE_STYLES: Record<string, { bg: string; text: string; label: string }> = {
  policy: { bg: 'bg-teal-900/40', text: 'text-teal-300', label: 'Policy' },
  sop: { bg: 'bg-emerald-900/40', text: 'text-emerald-300', label: 'SOP' },
  work_instruction: { bg: 'bg-amber-900/40', text: 'text-amber-300', label: 'Work Instruction' },
  form: { bg: 'bg-slate-700/40', text: 'text-slate-300', label: 'Form' },
  reference: { bg: 'bg-blue-900/40', text: 'text-blue-300', label: 'Reference' },
  unknown: { bg: 'bg-gray-700/40', text: 'text-gray-400', label: 'Unknown' },
};

export const DocumentTypeBadge = React.memo(function DocumentTypeBadge({
  type,
  size = 'sm',
}: {
  readonly type: string;
  readonly size?: 'xs' | 'sm';
}) {
  const style = TYPE_STYLES[type] ?? TYPE_STYLES.unknown;
  const sizeClass = size === 'xs' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-0.5 text-xs';

  return (
    <span className={`inline-flex items-center rounded font-semibold uppercase tracking-wide ${style.bg} ${style.text} ${sizeClass}`}>
      {style.label}
    </span>
  );
});
